/**
 * 待办列表统一关键词匹配：订单号、客户名、总价、应收账款等（含审批关联单客户/单号）。
 * 金额仅在关键词本身是金额形态时匹配：12800 / 12,800 / ¥12800 / 12.8k，以及金额数字片段包含。
 * 不匹配销售/助理名、审批标题文案，避免搜人名时因销售字段命中而带出无关客户行。
 */
export const matchPendingTotalPrice = (totalPrice, rawKeyword) => {
	if (totalPrice == null || totalPrice === '') return false;
	const normalized = String(rawKeyword)
		.replace(/[¥￥,\s]/g, '')
		.trim();
	if (!normalized) return false;

	const priceNum = Number(totalPrice);
	const priceStr = String(totalPrice);

	const kMatch = normalized.match(/^(\d+(?:\.\d+)?)k$/i);
	if (kMatch) {
		const approx = Number(kMatch[1]) * 1000;
		if (!Number.isFinite(approx) || !Number.isFinite(priceNum)) return false;
		const slack = Math.max(approx * 0.01, 1);
		return priceNum >= approx - slack && priceNum <= approx + slack;
	}

	if (!/^\d+(\.\d+)?$/.test(normalized)) return false;
	if (!Number.isFinite(priceNum)) return false;

	const amount = Number(normalized);
	if (!Number.isFinite(amount)) return false;
	if (priceNum === amount) return true;
	if (Math.floor(priceNum) === Math.floor(amount)) return true;
	if (priceStr.includes(normalized)) return true;
	return false;
};

export const matchPendingOrderKeyword = (row, keyword) => {
	const q = String(keyword ?? '')
		.trim()
		.toLowerCase();
	if (!q) return true;
	if (!row || typeof row !== 'object') return false;

	/** 与占位一致：订单号 / 客户名；审批标题可搜；不搜销售名与固定原因文案 */
	const haystack = [
		row.orderId,
		row.customerInfo?.customerName,
		row.customerName,
		row.title,
		row.approval?.title,
		row.approval?.detail?.orderId,
		row.approval?.detail?.customerName,
		row.approval?.detail?.customerInfo?.customerName,
		row.approval?.detail?.newCustomerConcatName,
		row.approval?.detail?.applyQuota,
		row.rejectReason,
		row.approval?.approvalSuggestions,
	]
		.filter(Boolean)
		.map((v) => String(v).toLowerCase());

	if (haystack.some((text) => text.includes(q))) return true;

	const raw = String(keyword ?? '').trim();
	if (matchPendingTotalPrice(row.totalPrice, raw)) return true;
	if (matchPendingTotalPrice(row.approval?.detail?.totalPrice, raw)) return true;
	if (matchPendingTotalPrice(row.currentAccountsReceivable, raw)) return true;
	if (matchPendingTotalPrice(row.quasiReceivable, raw)) return true;
	if (matchPendingTotalPrice(row.approval?.detail?.applyQuota, raw)) return true;
	return false;
};

export const filterPendingOrdersByKeyword = (orders, keyword) => {
	const list = Array.isArray(orders) ? orders : [];
	const q = String(keyword ?? '').trim();
	if (!q) return list;
	return list.filter((row) => matchPendingOrderKeyword(row, q));
};

export const countPendingOrdersByKeyword = (orders, keyword) => filterPendingOrdersByKeyword(orders, keyword).length;
